module.exports = __webpack_public_path__ + "img/start-button.2b37f707.png";